import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { UserContext, useRuntime } from '../../shell';
import { Shell } from '../types/shell';
export function UserContextProvider({ children }) {
    const runtime = useRuntime();
    const [username, setUsername] = useState(runtime.getSession().getActiveAccount()?.username.toLowerCase());
    const [isSGICanadaUser, setIsSGICanadaUser] = useState(runtime.getSession().getActiveAccount()?.idTokenClaims?.isVerifiedSgic);
    const name = runtime.getSession().getActiveAccount()?.name;
    useEffect(() => {
        if (runtime.shell === Shell.Customer && !username) {
            setUsername(runtime.getSession().getActiveAccount()?.idTokenClaims?.email);
        }
    }, [runtime, username]);
    // For medallia feedback
    window.SGIEmailAddress = username;
    // For medallia feedback
    return _jsx(UserContext.Provider, { value: { name, username, setUsername, isSGICanadaUser, setIsSGICanadaUser }, children: children });
}
